import { useTranslation } from "react-i18next";
import { Panel } from 'primereact/panel';
import { Card } from "primereact/card";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

export default function ListaConsulta({
  consulta,
  isConsultaNova,
}: {
  consulta: any;
  isConsultaNova?: boolean;
}) {
  const { t } = useTranslation();

  const consultas = consulta.consultas
    ? consulta.consultas.sort((a: any, b: any) => {
        const nameA = new Date('01/' + a.data);
        const nameB = new Date('01/' + b.data);
        if (nameA < nameB) return 1;
        if (nameA > nameB) return -1;
        return 0;
      })
    : null;

  if (isConsultaNova) {
    return (
      <div
        style={{
          backgroundColor: '#FFFFFF',
          borderRadius: '16px',
          border: '1px solid #E5E7EB',
          boxShadow: '0 4px 20px -2px rgba(0,0,0,0.05)',
          padding: '24px',
        }}
      >
        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
          <div
            style={{
              backgroundColor: '#EFF6FF',
              borderRadius: '10px',
              padding: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <i className="pi pi-search" style={{ color: '#2563EB', fontSize: '18px' }}></i>
          </div>
          <div>
            <h3 style={{ fontSize: '1rem', fontWeight: 700, margin: 0, color: '#1E3A8A' }}>
              {t('listaConsulta')}
            </h3>
            <span style={{ fontSize: 'small', color: '#6B7280' }}>
              {consultas?.length || 0} consulta{consultas?.length !== 1 ? 's' : ''} registrada{consultas?.length !== 1 ? 's' : ''}
            </span>
          </div>
        </div>

        {/* Table */}
        {consultas && consultas.length > 0 ? (
          <div style={{ overflowX: 'auto', borderRadius: '10px', border: '1px solid #F3F4F6' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
              <thead>
                <tr style={{ backgroundColor: '#F9FAFB', borderBottom: '2px solid #E5E7EB' }}>
                  <th
                    style={{
                      padding: '12px 16px',
                      fontWeight: 700,
                      color: '#6B7280',
                      fontSize: '0.75rem',
                      textTransform: 'uppercase',
                      letterSpacing: '0.05em',
                    }}
                  >
                    {t('segmento')}
                  </th>
                  <th
                    style={{
                      padding: '12px 16px',
                      fontWeight: 700,
                      color: '#6B7280',
                      fontSize: '0.75rem',
                      textTransform: 'uppercase',
                      letterSpacing: '0.05em',
                      width: '120px',
                      textAlign: 'center',
                    }}
                  >
                    {t('quantidade')}
                  </th>
                  <th
                    style={{
                      padding: '12px 16px',
                      fontWeight: 700,
                      color: '#6B7280',
                      fontSize: '0.75rem',
                      textTransform: 'uppercase',
                      letterSpacing: '0.05em',
                      width: '120px',
                      textAlign: 'right',
                    }}
                  >
                    {t('data')}
                  </th>
                </tr>
              </thead>
              <tbody>
                {consultas.map((c: any, idx: number) => (
                  <tr
                    key={idx}
                    style={{
                      borderBottom: idx < consultas.length - 1 ? '1px solid #F3F4F6' : 'none',
                      transition: 'background-color 0.15s ease',
                    }}
                    onMouseEnter={e => (e.currentTarget.style.backgroundColor = '#F9FAFB')}
                    onMouseLeave={e => (e.currentTarget.style.backgroundColor = 'transparent')}
                  >
                    <td style={{ padding: '14px 16px', fontWeight: 500, color: '#374151', fontSize: 'small' }}>
                      {c.segmento}
                    </td>
                    <td style={{ padding: '14px 16px', textAlign: 'center' }}>
                      <span
                        style={{
                          backgroundColor: '#F3F4F6',
                          color: '#1F2937',
                          fontSize: '0.75rem',
                          fontWeight: 700,
                          padding: '3px 10px',
                          borderRadius: '20px',
                          display: 'inline-block',
                        }}
                      >
                        {c.quantidade}
                      </span>
                    </td>
                    <td
                      style={{
                        padding: '14px 16px',
                        color: '#6B7280',
                        fontSize: '0.8rem',
                        fontWeight: 600,
                        textAlign: 'right',
                      }}
                    >
                      {c.data}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div
            style={{
              textAlign: 'center',
              padding: '40px',
              color: '#9CA3AF',
              fontSize: 'small',
            }}
          >
            <i className="pi pi-search" style={{ fontSize: '24px', marginBottom: '8px', display: 'block' }} />
            Nenhuma consulta registrada.
          </div>
        )}
      </div>
    );
  }

  return (
    <Panel header={t('listaConsulta')}>
      <div className="grid" style={{ display: "none" }}>
        <div className="col p-fluid flex flex-wrap">
          <Card style={{ backgroundColor: "rgba(255, 151, 0, 0.2)" }}>
            <span style={{ fontSize: "0.8rem", fontWeight: "700", color: 'rgb(255, 151, 0)' }}>{t('ultimos30Dias')}</span>
            <br></br>
            <span style={{ fontSize: "0.8rem", fontWeight: "700", color: 'rgb(255, 151, 0)' }}>{consulta.quantidade30Dias}</span>
          </Card>
        </div>
        <div className="col p-fluid flex flex-wrap">
          <Card style={{ backgroundColor: "rgba(126, 21, 227, 0.2)" }}>
            <span style={{ fontSize: "0.8rem", fontWeight: "700", color: 'rgb(126, 21, 227)' }}>{t('de31a60Dias')}</span>
            <br></br>
            <span style={{ fontSize: "0.8rem", fontWeight: "700", color: 'rgb(126, 21, 227)' }}>{consulta.quantidade31a60Dias}</span>
          </Card>
        </div>
        <div className="col p-fluid flex flex-wrap">
          <Card style={{ backgroundColor: "rgba(27, 87, 206, 0.2)" }}>
            <span style={{ fontSize: "0.8rem", fontWeight: "700", color: 'rgb(27, 87, 206)' }}>{t('de61a90Dias')}</span>
            <br></br>
            <span style={{ fontSize: "0.8rem", fontWeight: "700", color: 'rgb(27, 87, 206)' }}>{consulta.quantidade61a90Dias}</span>
          </Card>
        </div>
        <div className="col p-fluid flex flex-wrap">
          <Card style={{ backgroundColor: "rgba(31, 166, 133, 0.2)" }}>
            <span style={{ fontSize: "0.8rem", fontWeight: "700", color: 'rgb(31, 166, 133)' }}>{t('acima90Dias')}</span>
            <br></br>
            <span style={{ fontSize: "0.8rem", fontWeight: "700", color: 'rgb(31, 166, 133)' }}>{consulta.quantidadeMais90Dias}</span>
          </Card>
        </div>
      </div>
      <br></br>
      <DataTable size="small" value={consultas} tableStyle={{ minWidth: '50rem' }}>
        <Column field="segmento" header={t('segmento')}></Column>
        <Column field="quantidade" header={t('quantidade')}></Column>
        <Column field="data" header={t('data')}></Column>
      </DataTable>
    </Panel>
  );
}
